<template>
  <PopupTemplate @close="$emit('close')">
    <TemplateCambios v-if="paso == 'cambiarGdpr'">
      <div class="gdpr">
        <div class="cabecera">Comunicaciones contigo</div>
      </div>
      <div class="textoGdpr">
        <div class="campo1">
          <label>
            <input v-model="gdprEmpresas" type="checkbox" /> Acepto recibir
            promociones de MMT Seguros y empresas colaboradoras
          </label>
        </div>
      </div>

      <button class="pure-button boton" @click="actualizaGdpr()">
        Finalizar
      </button>
    </TemplateCambios>
    <ResultadoCambio
      v-if="paso == 'resultado'"
      :campo="'política de Protección de Datos'"
      :genero="'F'"
      class="gdpr"
      @siguiente="siguiente"
    />
    <div v-if="errorGdpr" class="noValido">{{ errorGdpr }}</div>
  </PopupTemplate>
</template>

<script>
export default {
  props: {
    cliente: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      paso: "cambiarGdpr",
      errorGdpr: "",
      gdprEmpresas: this.cliente.gdprEmpresas,
    };
  },

  methods: {
    actualizaGdpr: async function () {
      await this.$store.dispatch("actualizaGdpr", {
        gdprEmpresas: this.gdprEmpresas,
      });
      this.$store.dispatch("getPortfolio");
      this.paso = "resultado";
    },

    siguiente: async function () {
      switch (this.paso) {
        case "resultado":
          this.$emit("close");
          break;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.gdpr {
  min-width: 18rem;
}
.textoGdpr {
  font-size: 90%;
}
</style>
